import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processService = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_SERVICE, item)
}

export const fetchServices = (store) => {
    return axios.get(`/api/services`)
        .then(res => {
            _.each(res.data.data, item => processService(store, item))
            return res
        })
}

export const createService = (store, item) => {
    return axios.post(`/api/services`, item)
        .then(res => {
            processService(store, res.data.data)
            return res
        })
}

export const updateService = (store, item) => {
    return axios.patch(`/api/services/${item.id}`, item)
        .then(res => {
            processService(store, res.data.data)
            return res
        })
}

export const partialUpdateService = (store, item) => {
    return axios.patch(`/api/services/${item.id}/partial`, item)
        .then(res => {
            store.dispatch('processService', res.data.data)
            return res
        })
}

export const createOrUpdateService = (store, item) => {
    return item.id ?
        updateService(store, item) :
        createService(store, item)
}

export const removeService = (store, item) => {
    return axios.delete(`/api/services/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_SERVICE, item)
            return res
        })
}